export const SET_AGENTS = 'SET_AGENTS'
export const UPDATE_AGENT_SIGNED_IN = 'UPDATE_AGENT_SIGNED_IN'
export const SET_STATUS_LIST = 'SET_STATUS_LIST'
export const UPDATE_AGENTS = 'UPDATE_AGENTS'
export const RESET_AGENTS = 'RESET_AGENTS'
